<div class="shaka-modal" (click)="close()">
    <div class="shaka-wrapper" (click)="nothing($event)">
        <div class="shaka-close" (click)="close()">Close</div>
        <shaka-player-simple url="{{url}}" autoplay="true">
        </shaka-player-simple>
    </div>
</div>